import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { BasemodelService } from 'src/app/basemodel.service';

@Injectable({
  providedIn: 'root'
})
export class StudentCounsellingDetailsService {


  jwt = '';
  data: any;
  private baseUrl = '/employee/api/jwtV2';
  constructor(private http: HttpClient, public baseURL: BasemodelService) { }

  getacademic() {
    const headers = new HttpHeaders({
      'Authorization': this.jwt,
    });
    return this.http.get(this.baseURL.getCommonUrl() + "/employee/api/jwtV2/currentAcademicYear", { headers })
  }
  getstate() {
    const headers = new HttpHeaders({
      'Authorization': this.jwt,
    });
    return this.http.get(this.baseURL.getCommonUrl() + "/apiV2/common/employeeStates", { headers })

  }
  getcity(stateId: any) {
    const headers = new HttpHeaders({
      'Authorization': this.jwt,
    });
    return this.http.get(this.baseURL.getCommonUrl() + "/apiV2/common/emplStateCities?stateId=" + stateId, { headers })

  }
  getcampus(cityId: any) {
    const headers = new HttpHeaders({
      'Authorization': this.jwt,
    });
    return this.http.get(this.baseURL.getCommonUrl() + "/apiV2/common/empCityCampuses?cityId=" + cityId, { headers })
  }
  getcounseller(cityId: any, campusId?: any) {
    let url = this.baseURL.getCommonUrl() + '/employee/api/jwtV2/counsellors';
  url += `?cityId=${cityId}`;
  if (campusId) {
    url += `&campusId=${campusId}`;
  }
  return this.http.get(url);
  }
  getreasons() {
    const headers = new HttpHeaders({
      'Authorization': this.jwt,
    });
    return this.http.get(this.baseURL.getCommonUrl() + "/employee/api/jwtV2/categoryTypes", { headers })

  }
  getidentifiyiuess(reasonId: any) {
    const headers = new HttpHeaders({
      'Authorization': this.jwt,
    });
    return this.http.get(this.baseURL.getCommonUrl() + "/employee/api/jwtV2/categoryReasons?counselCatId=" + reasonId, { headers })
  }
  getCategoryDetails(params: {
    academicYear: string;
    cityId: number;
    campusId?: number;
    counsellorId?: number;
    counselCatId?: any;
  }): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': this.jwt,
    });

    let url = `${this.baseUrl}/categoryDetails?academicYear=${params.academicYear}&cityId=${params.cityId}`;

    if (params.campusId) {
      url += `&campusId=${params.campusId}`;
    }

    if (params.counsellorId) {
      url += `&createdBy=${params.counsellorId}`;
    }

    if (params.counselCatId) {
      url += `&counselCatId=${params.counselCatId}`;
    }

    return this.http.get<any>(this.baseURL.getCommonUrl() + url, { headers });
  }
  getreport(paramsObj: any) {
    const headers = new HttpHeaders({
      'Authorization': this.jwt,
    });
    let params = new HttpParams();

    Object.keys(paramsObj).forEach(key => {
      const value = paramsObj[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, value);
      }
    });

    return this.http.get(this.baseURL.getCommonUrl() + '/employee/api/jwtV2/counsellingDetailsReport', { params, headers });

  }
  searchData(searchCriteria:any) {

    // let payload=
    // {
    //   "admNo": (environment.apiUrl+"/ses/student/searchByAdmNo?searchCriteria,
    //   "businessType": "COLLEGE",
    //   "mobileNo": 0,
    //   "pageCount": 0,
    //   "parentName": "",
    //   "searchKey": searchTerm,
    //   "stdName": ""
    // }
    return this.http.get(this.baseURL.getcounsellingURL() + "/auth/jwt/student/counselDetailsByAdmNo?admNo=" + searchCriteria);
    // return this.http.get(this.baseURL.getcounsellingURL() +'/auth/jwt/student/counselDetails?admNo='+searchCriteria+'&stdCounselId='+counselId)
  }
  getdata() {

    return this.http.get(this.baseURL.getcounsellingURL() + "/auth/jwt/student/consellingDetails")
      .pipe(
        catchError((error) => {
          if (error.status === 401) {
            console.log('Access Denied:', error.message);
            // Handle 401 status code, e.g., show "Access Denied" message in the UI
          }

          return throwError(error);
        })
      );
  }


  getstudent() {

    return this.http.get(this.baseURL.getcounsellingURL() + "/auth/jwt/student/counsellingReport")
  }
  getdashboard(data1: any) {

    return this.http.get(this.baseURL.getcounsellingURL() + "/auth/jwt/student/campusWiseCounsellingReport?campusId=" + data1)
  }
  generatepdf(adm: any) {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + "a6a83a30-b51d-4bea-8af3-ac4a5cdae54c",
      "Accept": "application/pdf"
    }
    );
    {
      return this.http.get(this.baseURL.getcounsellingURL() + "/ses/stdCounselling/generatePdfReport?admNo=" + adm, { headers, responseType: 'blob' })
    }

  }
   getimage(admNo:any):Observable<Blob>{
     
     return this.http.get(this.baseURL.getCommonUrl()+"/student/login/v2/api/getUploadImage?admNo="+admNo,{responseType: 'blob'})
   }

}
